import { Button, ComponentType, useForm, useModal, Icon, appendClassName, Tooltip } from '@gcl/react-core';
import * as React from 'react';
import { AddTagForm } from './AddTagForm';
import { ITagViewItem } from './TagView';

interface IAddTagBtnProps {
  onAdd: (newTag: ITagViewItem) => void;
  small?: boolean;
  className?: string;
  existingTags: ITagViewItem[];
}
export const AddTagBtn = ({ onAdd, className = '', small = false, existingTags }: IAddTagBtnProps) => {
  const useFormMethods = useForm({
    mode: 'onSubmit',
    shouldFocusError: true,
  });
  const { openPortal, closePortal, renderModal } = useModal();

  const handleSubmit = (data: any) => {
    const tag = data as { type: { id: number; name: string }; name: string };
    onAdd({
      tagTypeName: tag.type.name,
      tagTypeId: tag.type.id,
      name: tag.name,
    });
    if (closePortal && typeof closePortal === 'function') closePortal();
  };

  const onClickAddTag = (e: any) => {
    useFormMethods.reset();
    openPortal(e);
  };

  const AddBtn = React.useMemo(() => {
    return small ? (
      <div className="gcl-clickable" onClick={onClickAddTag}>
        <Tooltip overlay="Add Tag" id="gcl-gems-tag-view-add-btn-tooltip">
          <Icon
            iconName="PlusLg"
            size={22}
            className="gcl-ic-btn-lg gcl-ml-sm gcl-fc-primary-400"
            data-testid="t1-form-add-tag-btn"
          />
        </Tooltip>
      </div>
    ) : (
      <Button
        suffixIconName="PlusLg"
        onClick={onClickAddTag}
        className={appendClassName('gcl-clickable', appendClassName('gcl-gems-tag-add', className))}
      >
        Add Tag
      </Button>
    );
  }, [small]);

  return (
    <>
      {AddBtn}
      {renderModal({
        title: 'Create Tag',
        onRenderBody: () => {
          return <AddTagForm useFormMethods={useFormMethods} existingTags={existingTags} />;
        },
        onRenderFooter: (onHide?: () => void) => {
          return (
            <div>
              <Button
                type={ComponentType.Primary}
                onClick={async (event) => {
                  await useFormMethods.handleSubmit(handleSubmit)();
                }}
              >
                Save
              </Button>
            </div>
          );
        },
      })}
    </>
  );
};
